module.exports = __webpack_public_path__ + "static/media/dtcpak.2eeda62d.png";